<ng-template #tooltipBody>
    <ul class="list-unstyled mb-0">
        <li *ngFor="let item of listAlert;">
            {{item}}
        </li>
    </ul>
</ng-template>

<span class="badge badge-pill"
    [ngClass]="itemColor"
    placement="top"
    [ngbTooltip]="tooltipBody"
    container="body">
    <i class="fas fa-exclamation-triangle"></i>
</span>